import { read, utils, writeFile } from 'xlsx';
import Button from '../../StoraEnsoComponents/Button';
import styled from 'styled-components';
import { ReactComponent as FileExcelSvg } from '../../../assets/icons/file-excel.svg';
import { useEffect } from 'react';


function ExportTableToXLSX({tableData, headers, projectName}) {
  const ExcelIcon = styled(FileExcelSvg)``;

  const exportXLSX = () => {
    const worksheet = utils.json_to_sheet(tableData);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, projectName);
    writeFile(workbook, `${projectName}.xlsx`);
  }

  return (
    <div>
      <Button icon={<ExcelIcon />} onClick={exportXLSX} size="sm">Generate Excel</Button>
    </div>
  )
}
export default ExportTableToXLSX;